// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-CloseButton----index-module---root---2wPy_","rootInverted":"src-components-CloseButton----index-module---rootInverted---1gw_b src-components-CloseButton----index-module---root---2wPy_","closeIcon":"src-components-CloseButton----index-module---closeIcon---hlJ9q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseButton/index.module.css
// module id = 599
// module chunks = 114276838955818